var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"atom-reading-number",attrs:{"color":"error","fab":"","dark":""}},[_vm._v("\n  "+_vm._s(_vm.number)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }